const viewEventDetailsAdminPath = '/events/summary.php?ev_id=';

class InvitationPositionDisplayBox {
  constructor(
    $timeout,
    LogService,
    StaffUserService,
    ClientService,
    DateTimeService,
    APIService,
    DEBUG
  ) {
    "ngInject";
    this.$timeout = $timeout;
    this.LogService = LogService;
    this.StaffUserService = StaffUserService;
    this.ClientService = ClientService;
    this.DateTimeService = DateTimeService;
    this.APIService = APIService;
    this.DEBUG = DEBUG;

    this._isCommunicating = false;
    this._status = '';

    this._constructed = true;
  }

  $onInit() {
    this._updateClientForCurrentPosition();
  }

  get debug() {
    return this.DEBUG;
  }

  set isOnline(val) {
    this._isOnline = val;
  }

  get isOnline() {
    if (this.APIService) {
      return this.APIService.isOnline;
    }
    return false;
  }

  set position(position) {
    this._position = position;
    this._updateClientForCurrentPosition();
  }

  get position() {
    return this._position;
  }

  get positionStartTimeInEventTimezone() {
    const startTime = this.position && this.position.start_time;
    const eventTimezoneName = this.position && this.position.event && this.position.event.timezoneName;
    return this.DateTimeService.parseMomentWithTimezone(startTime, eventTimezoneName);
  }

  get positionEndTimeInEventTimezone() {
    const endTime = this.position && this.position.end_time;
    const eventTimezoneName = this.position && this.position.event && this.position.event.timezoneName;
    return this.DateTimeService.parseMomentWithTimezone(endTime, eventTimezoneName);
  }

  get eventId() {
    return this.position && (this.position.events_id || this.position.real_events_id);
  }

  get clientInfo() {
    if (this._clientInfo === undefined) {
      let clientId = this.clientId;
      this._clientInfo = `${clientId}`;
      if (clientId) {
        this.ClientService.getById(clientId)
          .then(client => {
            if (client) {
              this._clientInfo = `${client.name} (host: ${client.host_prefix} id: ${client.id})`;
            } else {
              this.LogService.warn("Unable to load client with id", clientId);
            }
          })
      }
    }
    return this._clientInfo;
  }

  get client() {
    return this._client;
  }

  get clientId() {
    return this.position && this.position.clients_id;
  }

  get clientName() {
    return this.client && this.client.name;
  }

  get clientHostPrefix() {
    return this.client && this.client.host_prefix;
  }

  get viewEventDetailsAdminURL() {
    let hostPrefix = this.clientHostPrefix,
      eventId = this.eventId;
    if (!hostPrefix || !eventId) {
      return null;
    }
    let path = viewEventDetailsAdminPath + eventId;
    return this.APIService.convertPathToURLWithHostPrefix(path, hostPrefix);
  }

  isCommunicating() {
    return this._isCommunicating;
  }

  getStatus() {
    return this._status;
  }

  applyForPosition() {
    this._isCommunicating = true;
    this.StaffUserService.acceptPosition(this.position)
      .then(() => {
        this._isCommunicating = false;
        this._status = 'Applied';
      });

  }

  declinePosition() {
    this._isCommunicating = true;
    this.StaffUserService.declinePosition(this.position)
      .then(() => {
        this._isCommunicating = false;
        this._status = 'Declined';
      });
  }

  _updateClientForCurrentPosition() {
    if (!this._constructed) {
      return;
    }

    const clientId = this.position && this.position.clients_id;
    const eventId = this.position && (this.position.events_id || this.position.real_events_id);
    const positionId = this.position && this.position.id;

    this.LogService.debug(`InvitationPositionDisplayBox._updateClientForCurrentPosition. Position:`, this.position);

    if (clientId && this.ClientService) {
      this.ClientService.getById(clientId)
        .then(client => {
          if (!client) {
            this.LogService.warn(`ClientService.getById(${clientId}) returned null; not updating client for event ${eventId} position ${positionId}`);
            return;
          }
          this.$timeout(() => {
            this.LogService.debug(`Setting client for event ${eventId} position ${positionId} to`, client);
            this._client = client;
          });
        })
        .catch(err => {
          this.LogService.warn(`Error retrieving client for event ${eventId} position ${positionId}:`, err);
          this._client = null;
        });
    } else {
      this.LogService.warn(`Unable to retreive client info for event ${eventId} position ${positionId}; missing clients id. Position:`, this.position);
      this._client = null;
    }
  }
}

export default InvitationPositionDisplayBox;

